import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=1d2c556e&scoped=true&"
import script from "./Consent.vue?vue&type=script&lang=js&"
export * from "./Consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c556e",
  null
  
)

export default component.exports